export const ORDER_VALUE = 100;

export const BASE_MNTN_URL = 'https://dx.mountain.com/spx?shaid=35475&';

const CACHE_BUSTER_MAX = 100000000000000000; // 10^17

export const getReferrer = (maxLength: number): string => {
  try {
    const topReferrer = top?.document.referrer;
    if (topReferrer) return encodeURIComponent(topReferrer.substring(0, maxLength));
  } catch {
    // Cross-origin access denied, fall through to document.referrer
  }

  const referrer = document.referrer;
  if (referrer) return encodeURIComponent(referrer.substring(0, maxLength));

  return '';
};

export const getPageLocation = (maxLength: number): string => {
  try {
    const parentHref = parent.location.href;
    if (parentHref) return encodeURIComponent(parentHref.substring(0, maxLength));
  } catch {
    // Cross-origin access denied, fall back to current window location
  }

  const locationHref = getLocationHref();
  if (locationHref) return encodeURIComponent(locationHref.substring(0, maxLength));

  return '';
};

export const getLocationHref = (): string => {
  try {
    // Try to get the top window's location (most accurate for iframes)
    const topHref = window.top?.location.href;
    if (topHref) return topHref;
  } catch {
    // Cross-origin access denied, fall through to document.location
  }

  // Fallback to current document location
  return document.location.href;
};

export const generateCacheBuster = (): number => {
  return Math.floor(Math.random() * CACHE_BUSTER_MAX);
};
